import { fetch } from '../../services/api';
import QueryBuilder from '../../components/WHTable/queryBuilder';
import configApi from '../../constants/ApiConfig';

const endPoints = '/api/medias';
const endPointsApi = '/api/media';

export const search = (data) => {
    
    let query = QueryBuilder(data); 

    return fetch(endPointsApi, query, 'get')

};

export const viewFromUrl = (url) => fetch(`${configApi.assetUrl}${url}`, {}, 'get', true);

export const getAsset = (media) => {

    if(!media || !media.url) return null;

    if(media.external) {

        return (`${media.url}`);

    }else{

        return (`${configApi.assetUrl}${media.url}`);

    }

}

export const view = (id) => fetch(`${endPoints}/${id}`, 'get');

export const create = (data) => fetch(`${endPoints}`, data, 'post');

export const update = (id, data) => fetch(`${endPoints}/${id}`, data, 'put');

export const remove = (id) => fetch(`${endPoints}/${id}`, {}, 'delete');


// WEBPACK FOOTER //
// ./src/services/media/index.js